module.exports = __webpack_public_path__ + "img/block2-3-mobile.c5bc12a1.jpg";